import VueGtag, { useGtag } from 'vue-gtag-next';
import { getConfig } from './config.js';

const gaMeasurementId = getConfig('VITE_GA_MEASUREMENT_ID')
const { event } = useGtag();

/**
 * Initialize Google Analytics for the application.
 *
 * @param {import('vue').App} app - The Vue application to initialize analytics for.
 */
function initAnalytics(app) {
  if (!gaMeasurementId) return;
  app.use(VueGtag, {
    property: {
      id: gaMeasurementId
    }
  });
}

/**
 * Send an analytics event to Google Analytics.
 *
 * @param {string} eventName - The name of the event.
 * @param {string} category - The category of the event.
 * @param {string} action - The action of the event.
 */
function analyticsEvent(eventName, category, action) {
  console.log("sending analytics: ", eventName, category, action);
  event(eventName, {
    action,
    category,
  });
}


export { analyticsEvent, initAnalytics };